require('core-js');

const isDefinedIntersectionObserver =
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
    'isIntersecting' in window.IntersectionObserverEntry.prototype;

const isResizeObserverSupported = 'ResizeObserver' in window;

const isSmoothScrollDefined = 'scrollBehavior' in document.documentElement.style;

function loadSmoothScroll() {
    return import(/* webpackChunkName: "smoothscroll-polyfill" */ 'smoothscroll-polyfill').then((module) => {
        const m = module.default ? module.default : module;
        m.polyfill();
        return m;
    });
}

module.exports = Promise.all(
    [
        // eslint-disable-next-line no-restricted-properties
        !window.fetch && import(/* webpackChunkName: "whatwg-fetch" */ 'whatwg-fetch'),
        !isDefinedIntersectionObserver && import(/* webpackChunkName: "intersection-observer" */ 'intersection-observer'),
        !isResizeObserverSupported && import(/* webpackChunkName: "resize-observer-polyfill" */ 'resize-observer-polyfill'),
        !isSmoothScrollDefined && loadSmoothScroll(),
    ].filter(Boolean)
);
